import React, { useState } from 'react';
import axios from 'axios';

function NewsTitle() {
  const [name, setName] = useState('');
  const [pdf, setPdf] = useState(null);
  const [message, setMessage] = useState('');

  const handleUpload = async (e) => {
    e.preventDefault();

    // ✅ Name required, PDF optional
    if (!name.trim()) {
      setMessage("Name is required.");
      return;
    }

    const formData = new FormData();
    formData.append('name', name);

    if (pdf) {
      formData.append('pdf', pdf);
    }

    try {
      const response = await axios.post(
        'https://peralassery.cubixsystems.com/myapp/upload_notice.php',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const res = response.data;

      if (res.success) {
        setMessage("Saved successfully ✅");
        setName('');
        setPdf(null);
        document.querySelector('.fileupload').value = ''; // reset file input
        window.location.reload();
      } else {
        setMessage(res.message || "Upload failed");
      }
    } catch (error) {
      console.error(error);
      setMessage("An error occurred during upload.");
    }
  };

  return (
    <div>
      <h4 style={{ marginBottom: '6px', fontWeight: '600', paddingBottom: '6px' }}>
        Updates
      </h4>

      <form onSubmit={handleUpload}>
        <div className="row">

          <div className="col-md-12" style={{ marginBottom: '15px' }}>
            <textarea
              className="form-control textlatest"
              placeholder="Enter Title"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="col-md-12" style={{ marginBottom: '15px' }}>
            <input
              className="form-control fileupload"
              type="file"
              accept="application/pdf"
              onChange={(e) => setPdf(e.target.files[0] || null)}
            />
          </div>

          <div className="col-md-12">
            <button type="submit" className="btn btn-primary firstbuttoncolor">
              Save
            </button>
          </div>

        </div>
      </form>

      {message && <p style={{ marginTop: '10px' }}>{message}</p>}
    </div>
  );
}

export default NewsTitle;
